import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import LeadTable from "./Lead";
import { getApi } from "common/services/api";
import { postApi } from "common/services/api";
import Spinner from "common/components/spinner/Spinner";
import { GiClick } from "react-icons/gi";
import { toast } from "react-toastify";

const ContactModel = (props) => {
  const { onClose, isOpen, fieldName, setFieldValue, data } = props;
  const [selectedValues, setSelectedValues] = useState();
  const [isLoading, setIsLoading] = useState(false);
  // const [data, setData] = useState([])

  const columns = [
    { Header: "#", accessor: "_id", isSortable: false, width: 10 },
    { Header: "Lead Name", accessor: "leadName", width: 20 },
    { Header: "Lead Email", accessor: "leadEmail" },
    { Header: "Lead PhoneNumber", accessor: "leadPhoneNumber" },
    { Header: "Lead Address", accessor: "leadAddress" },
    { Header: "Lead Status", accessor: "leadStatus" },
    { Header: "Lead Owner", accessor: "leadOwner" },
    { Header: "Lead Score", accessor: "leadScore" },
  ];

  const user = JSON.parse(localStorage.getItem("user"));
  // const fetchLeadData = async () => {
  //     setIsLoading(true)
  //     let result = await getApi(user.role === 'superAdmin' ? 'api/lead/' : `api/lead/?createBy=${user._id}`);
  //     if (result && result.status == 200) {
  //         setData(result?.data);
  //     }
  //     setIsLoading(false)
  // }

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setFieldValue(fieldName, selectedValues);
      onClose();
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal onClose={onClose} size="full" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Lead</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Flex justifyContent={"center"} alignItems={"center"} width="100%">
              <Spinner />
            </Flex>
          ) : (
            <LeadTable
              tableData={data}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              columnsData={columns}
              title="Lead"
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="brand"
            className="theme-btn1"
            size="sm"
            me={2}
            onClick={handleSubmit}
            disabled={isLoading ? true : false}
            leftIcon={<GiClick />}
          >
            {" "}
            {isLoading ? <Spinner /> : "Select"}
          </Button>
          <Button
            variant="outline"
            className="theme-btn2"
            size="sm"
            colorScheme="red"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ContactModel;
